import React from "react";
import "./project_list_css/CsrProjectsHeader.css";

/* ✅ HEADER DATA OBJECT */
const headerData = {
  title: "CSR Projects",
  subtitle:
    "Browse and track Corporate Social Responsibility projects across Maharashtra",
  // totalProjects: 8,
};

const CsrProjectsHeader = ({ projectCount }) => {
  const { title, subtitle, totalProjects } = headerData;

  return (
    <div className="csr-header">
      <div className="container-fluid">
        <div className="row align-items-center gy-3">
          {/* Left Content */}
          <div className="col-lg-9 col-md-8 col-12">
            <h1 className="project-title ">{title}</h1>
            <p className="project-subtitle mb-0 text-white">{subtitle}</p>
          </div>

          {/* Right Card */}
          <div className="col-lg-3 col-md-4 col-12 text-md-end">
            <div className="total-projects-card mx-md-0 mx-auto">
              <div className="total-label">Total Projects</div>
              <div className="total-count">{projectCount}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CsrProjectsHeader;